import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import Panel from '../../layout/Panel';
import { Create as CreateIcon } from '@mui/icons-material';
import PromptLibrary from './PromptLibrary';
import PromptBuilder from './PromptBuilder';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`gate-tabpanel-${index}`}
      aria-labelledby={`gate-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

export default function Gate() {
  const [activeTab, setActiveTab] = useState(0);
  const [editingPrompt, setEditingPrompt] = useState(null);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handlePromptCreated = () => {
    // Switch to library tab and refresh
    setActiveTab(0);
    setEditingPrompt(null);
  };

  const handleCreateNew = () => {
    setEditingPrompt(null);
    setActiveTab(1);
  };

  const handleEditPrompt = (prompt) => {
    // Switch to create/edit tab with the prompt data
    setEditingPrompt(prompt);
    setActiveTab(1);
  };

  const handleTestPrompt = (prompt) => {
    // TODO: Navigate to Live Trial with this prompt selected
    console.log('Test prompt:', prompt);
  };

  return (
    <Panel 
      title="Prompt Management"
      icon={<CreateIcon />}
      contentSx={{ p: 0 }}
    >
      <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 3 }}>
        <Tabs value={activeTab} onChange={handleTabChange}>
          <Tab label="My Prompts" />
          <Tab label="Create New" />
        </Tabs>
      </Box>

      <Box sx={{ px: 3, pb: 3 }}>
        <TabPanel value={activeTab} index={0}>
          <PromptLibrary 
            onCreateNew={handleCreateNew}
            onEditPrompt={handleEditPrompt}
            onTestPrompt={handleTestPrompt}
          />
        </TabPanel>
        
        <TabPanel value={activeTab} index={1}>
          <PromptBuilder 
            onPromptCreated={handlePromptCreated}
            editingPrompt={editingPrompt}
          />
        </TabPanel>
      </Box>
    </Panel>
  );
}
